import {
  createEconnectorClient,
  DeleteOperation,
  deleteRequestFactory,
  FindOperation,
  getRequestFactory,
  postRequestFactory,
  putRequestFactory,
  SaveOperation,
  SearchOperation,
  searchRequestFactory
} from '@infuse/api/common';

import { ChargingStation, CreateChargingStation, ImportChargingStationsResponse, LinkRequest } from './model';

const client = createEconnectorClient('/api/chargepoints');
const clientForImport = createEconnectorClient('/api/chargepoints/import', { 'Content-Type': 'multipart/form-data' });

export const chargingStationPermissions = {
  SEARCH: 'econnector.search-charging-stations',
  GET: 'econnector.get-charging-station',
  CREATE: 'econnector.create-charging-station',
  UPDATE: 'econnector.update-charging-station',
  DELETE: 'econnector.delete-charging-station',
  LINK: 'econnector.link-to-central-systems',
  IMPORT_CSV: 'econnector.csv-import',
  GET_CSV_IMPORT_TEMPLATE: 'econnector.get-csv-import-template'
};

export const searchChargingStations: SearchOperation<ChargingStation> = searchRequestFactory<ChargingStation>(client, {
  permissionId: chargingStationPermissions.SEARCH
});

export const getChargingStation: FindOperation<ChargingStation, string> = getRequestFactory<ChargingStation, string>(client, {
  permissionId: chargingStationPermissions.GET
});

export const createChargingStation: SaveOperation<CreateChargingStation> = postRequestFactory<CreateChargingStation, ChargingStation>(
  client,
  { pattern: '', permissionId: chargingStationPermissions.CREATE }
);

export const updateChargingStation: SaveOperation<ChargingStation> = putRequestFactory<ChargingStation, ChargingStation>(client, {
  permissionId: chargingStationPermissions.UPDATE
});

export const deleteChargingStation: DeleteOperation<ChargingStation, void> = deleteRequestFactory<ChargingStation, void>(client, {
  permissionId: chargingStationPermissions.DELETE
});

export const linkChargingStation: SaveOperation<LinkRequest, void> = postRequestFactory<LinkRequest, void>(client, {
  pattern: '/{id}/link',
  permissionId: chargingStationPermissions.LINK
});

export const importChargingStations: SaveOperation<FormData, ImportChargingStationsResponse> = postRequestFactory<
  FormData,
  ImportChargingStationsResponse
>(clientForImport, { pattern: '', permissionId: chargingStationPermissions.IMPORT_CSV });

export const downloadCsvTemplateUrl: string = client.defaults.baseURL + '/import';
